/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AdminAppConfigsService } from './services/admin-app-configs.service';
import { AdminPdfsService } from './services/admin-pdfs.service';
import { AdminProgramsService } from './services/admin-programs.service';
import { AdminProgramPeriodsService } from './services/admin-program-periods.service';
import { AdminProgramPeriodConfigsService } from './services/admin-program-period-configs.service';
import { AdminQualitySectionConfigService } from './services/admin-quality-section-config.service';
import { AdminReasonCodesService } from './services/admin-reason-codes.service';
import { AdminReportingReportUrlService } from './services/admin-reporting-report-url.service';
import { AuditProgramService } from './services/audit-program.service';
import { AuditProgramPeriodService } from './services/audit-program-period.service';
import { AuditFormsService } from './services/audit-forms.service';
import { AuditingReopenService } from './services/auditing-reopen.service';
import { BulkFormActionsService } from './services/bulk-form-actions.service';
import { AuditFormRiskEntryService } from './services/audit-form-risk-entry.service';
import { AuditHistoryService } from './services/audit-history.service';
import { BulkPrintService } from './services/bulk-print.service';
import { DataMartProfilesService } from './services/data-mart-profiles.service';
import { DataMartAdvancedSearchService } from './services/data-mart-advanced-search.service';
import { ReportingReportUrlService } from './services/reporting-report-url.service';
import { FormsService } from './services/forms.service';
import { FormCustomService } from './services/form-custom.service';
import { FormProfileSnapshotService } from './services/form-profile-snapshot.service';
import { FormQualityEntryService } from './services/form-quality-entry.service';
import { FormQualitySectionService } from './services/form-quality-section.service';
import { FormRiskEntryService } from './services/form-risk-entry.service';
import { FormSignatureService } from './services/form-signature.service';
import { FormSnapshotRequestService } from './services/form-snapshot-request.service';
import { AppConfigsService } from './services/app-configs.service';
import { NotesService } from './services/notes.service';
import { AttachmentsService } from './services/attachments.service';
import { ProgramsService } from './services/programs.service';
import { ProgramPeriodConfigsService } from './services/program-period-configs.service';
import { ProgramPeriodsService } from './services/program-periods.service';
import { QualitySectionConfigsService } from './services/quality-section-configs.service';
import { ReasonCodesService } from './services/reason-codes.service';
import { AuditorUsersService } from './services/auditor-users.service';
import { CurrentUserService } from './services/current-user.service';
import { SubmitterUsersService } from './services/submitter-users.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AdminAppConfigsService,
    AdminPdfsService,
    AdminProgramsService,
    AdminProgramPeriodsService,
    AdminProgramPeriodConfigsService,
    AdminQualitySectionConfigService,
    AdminReasonCodesService,
    AdminReportingReportUrlService,
    AuditProgramService,
    AuditProgramPeriodService,
    AuditFormsService,
    AuditingReopenService,
    BulkFormActionsService,
    AuditFormRiskEntryService,
    AuditHistoryService,
    BulkPrintService,
    DataMartProfilesService,
    DataMartAdvancedSearchService,
    ReportingReportUrlService,
    FormsService,
    FormCustomService,
    FormProfileSnapshotService,
    FormQualityEntryService,
    FormQualitySectionService,
    FormRiskEntryService,
    FormSignatureService,
    FormSnapshotRequestService,
    AppConfigsService,
    NotesService,
    AttachmentsService,
    ProgramsService,
    ProgramPeriodConfigsService,
    ProgramPeriodsService,
    QualitySectionConfigsService,
    ReasonCodesService,
    AuditorUsersService,
    CurrentUserService,
    SubmitterUsersService,
    ApiConfiguration,
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: ApiModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
